<template>
  <g v-if="isInvisible">
    <defs v-if="lineInfo.fromY === lineInfo.toY">
      <linearGradient :id="gradientId"
                      x1="0%" y1="0%" x2="100%" y2="0%">
        <stop stop-color="#ffffff" offset="50%"></stop>
        <stop stop-color="#ffffff" offset="100%" stop-opacity="0"></stop>
      </linearGradient>
      <mask :id="maskId" maskUnits="userSpaceOnUse">
        <rect v-bind="lineMaskAttributes" />
      </mask>
    </defs>
    <defs v-else>
      <linearGradient :id="gradientId"
                      x1="0%" y1="0%" x2="0%" y2="100%">
        <stop stop-color="#ffffff" :offset="verticalGradientOffsetFrom"></stop>
        <stop stop-color="#ffffff" :offset="verticalGradientOffsetTo" stop-opacity="0"></stop>
      </linearGradient>
      <mask :id="maskId" maskUnits="userSpaceOnUse">
        <rect v-bind="lineMaskAttributes" />
      </mask>
    </defs>
    <path :d="pathDescription"
          :stroke="'url(#path-svg-gradient-' + sequenceIndex + ')'"
          :stroke-width="lineWidth"
          :mask="'url(#' + maskId + ')'" />
  </g>
  <path v-else
        :d="pathDescription"
        :stroke="'url(#path-svg-gradient-' + sequenceIndex + ')'"
        :stroke-width="lineWidth" />
</template>

<script>
export default {
  name: 'BaTargetingNodePath',
  components: {
  },
  props: {
    sequenceIndex: {
      type: Number,
      required: true
    },
    nodeIndex: {
      type: Number,
      required: true
    },
    lineInfo: {
      type: Object,
      required: true
    },
    isInvisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    lineWidth () {
      return Math.max(1, Math.ceil(this.lineInfo.width))
    },
    gradientId () {
      return 'cropped-line-linear-gradient-' + this.sequenceIndex + '-' + this.nodeIndex + (this.lineInfo.combined ? '-combined' : '')
    },
    maskId () {
      return 'cropped-line-linear-gradient-mask-' + this.sequenceIndex + '-' + this.nodeIndex + (this.lineInfo.combined ? '-combined' : '')
    },
    lineMaskAttributes () {
      const lineInfo = this.lineInfo
      const attributes = {
        x: 0,
        y: Math.min(lineInfo.fromY, lineInfo.toY) - 30,
        width: lineInfo.toX / 2,
        height: Math.abs(lineInfo.fromY - lineInfo.toY) + 60,
        fill: 'url(#' + this.gradientId + ')'
      }
      if (lineInfo.fromY !== lineInfo.toY) {
        attributes.width = lineInfo.toX / 1.5
      }
      return attributes
    },
    verticalGradientOffsetFrom () {
      const height = this.lineMaskAttributes.height
      return (this.lineInfo.cutted ? (Math.max(0, height - 200) / height) * 100 : this.sequenceIndex === 1 ? 40 : 30) + '%'
    },
    verticalGradientOffsetTo () {
      const height = this.lineMaskAttributes.height
      return (this.lineInfo.cutted ? (Math.max(0, height - 100) / height) * 100 : this.sequenceIndex === 1 ? 80 : 60) + '%'
    },
    pathDescription () {
      const lineInfo = this.lineInfo
      const { fromX, fromY, toX, toY, centerX, cutted, radius } = lineInfo
      let description = []

      if (cutted) {
        description.push(
          'M', fromX, fromY - 0.5,
          'L', fromX, Math.max(fromY, toY + (this.sequenceIndex === 1 && this.isInvisible ? 30 : 0) - radius)
        )
        if (!this.isInvisible) {
          description.push(
            'Q', fromX, toY, toX - radius, toY,
            'L', toX, toY
          )
        }
      } else if (fromY === toY) {
        description.push(
          'M', fromX, fromY,
          'L', this.isInvisible ? (toX - fromX) / 2 : toX, toY + 0.0001
        )
      } else if (this.sequenceIndex === 1) {
        const centerY = lineInfo.combined ? toY : toY > fromY ? fromY + (toY - fromY) / 2 : toY + (fromY - toY) / 2
        description.push(
          'M', fromX, fromY,
          'L', fromX + 100 + 45, fromY,
          'Q', centerX, fromY, centerX, toY > fromY ? Math.min(fromY + radius, centerY) : Math.max(fromY - radius, centerY),
          'L', centerX, toY > fromY ? Math.max(toY - radius, centerY) : Math.min(toY + radius, centerY),
          'Q', centerX, toY, centerX + radius, toY,
          'L', toX, toY
        )
      } else {
        description.push(
          'M', fromX, fromY,
          'L', centerX - radius, fromY,
          'Q', centerX, fromY, centerX, fromY + radius
        )
        if (!this.isInvisible) {
          description.push(
            'L', centerX, toY - radius,
            'Q', centerX, toY, centerX + radius, toY,
            'L', toX, toY
          )
        }
      }

      if (lineInfo.combined && description.length > 12) {
        description = description.slice(0, description.length - 8)
        description[description.length - 1] = Math.min(description[description.length - 1] + radius, lineInfo.maxY)
      }

      return description.join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
